module.exports = __webpack_public_path__ + "static/media/study 220125.1c42055c.png";